module.exports = __webpack_public_path__ + "static/media/sherryma.8a5693b4.jpeg";